<template>
    <el-dialog
        class="config_qualification_dialog"
        title="资质配置"
        :visible.sync="openConfigQlfDialog"
        top="4%"
        width="30%"
        :before-close="closeDialog">
        <el-tree
            ref="tree"
            style=" overflow: overlay;height: 300px;"
            :data="treeData"
            show-checkbox
            node-key="qualificationConfigCode"
            @check-change="handleCheckChange"
            :default-expand-all="true"
            :props="defaultProps"
            :render-content="renderContent">
        </el-tree>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="confirmDialog">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
import _ from '@/components/lots/utils';
import { dictWithUrl } from '@/components/lots/api';

export default {
    name: 'config-qualification-dialog',
    components: {},
    props: {
        openConfigQlfDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        qlfData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            checkedKeys: [],
            qualificationType: null,
            treeData: [{
                qualificationConfigCode: 'root1',
                qualificationName: '基本资质',
                children: []
            }],
            defaultProps: {
                children: 'children',
                label: 'qualificationName',
                value: 'value'
            }
        };
    },
    methods: {
        closeDialog() {
            this.clear();
            this.$emit('closeDialog', false);
        },
        confirmDialog() {
            const data = [];
            this.treeData.forEach(tItem => {
                tItem.children.forEach(child => {
                    if (this.checkedKeys.indexOf(child.qualificationConfigCode) >= 0) {
                        child.requiredFlag = 1;
                    } else {
                        child.requiredFlag = 0;
                    }
                    child.qualificationType = this.qualificationType;
                    data.push(child);
                });
            });
            this.$emit('confirmDialog', { data: _.clone(data), close: false });
            this.clear();
        },
        handleCheckChange() {
            // window.console.log(data, checked, indeterminate);
            const checkedNodes = this.$refs.tree.getCheckedNodes();
            const keys = [];
            checkedNodes.forEach(item => {
                if (!item.children) {
                    keys.push(item.qualificationConfigCode);
                }
            });
            this.checkedKeys = keys;
        },
        clear() {
            this.$refs.tree.setCheckedKeys([]);
        },
        renderContent(h, { node, data, store }) {
            return (<span class="custom-tree-node"><span>{node.label}</span></span>);
        },
        initTree(qtDict, bqDict) {
            for (const key in qtDict) {
                if (qtDict[key] === '基本资质') {
                    this.qualificationType = key;
                }
            }

            const children = []
            const INVOICE_DICT_CODES = ['12', '25', '26', '27', '28'] // 开票底联凭证 相关资质排序数组
            const invoiceChildren = [] // 开票底联凭证 相关资质
            const SU_SCORE_DICT_CODES = ['16', '13', '14', '15', '29'] // 供应商评分表 相关资质排序数组
            const suScoreChildren = [] // 供应商评分表 相关资质
            for (const code in bqDict) {
                if (bqDict[code] && !INVOICE_DICT_CODES.includes(code) && !SU_SCORE_DICT_CODES.includes(code)) {
                    children.push({
                        qualificationConfigCode: code,
                        qualificationName: bqDict[code]
                    });
                }
            }

            INVOICE_DICT_CODES.forEach(code => {
                if (bqDict[code]) {
                    invoiceChildren.push({
                        qualificationConfigCode: code,
                        qualificationName: bqDict[code]
                    })
                }
            })

            SU_SCORE_DICT_CODES.forEach(code => {
                if (bqDict[code]) {
                    suScoreChildren.push({
                        qualificationConfigCode: code,
                        qualificationName: bqDict[code]
                    })
                }
            })

            this.treeData[0].children = children.concat(invoiceChildren).concat(suScoreChildren);
        },
        setData(val) {
            const defaultCheckedKeys = [];
            this.treeData = _.clone(this.treeData.map(data => {
                data.children = data.children.map(child => {
                    const filtedArr = val.filter(qlfItem => +qlfItem.qualificationConfigCode === +child.qualificationConfigCode);
                    if (filtedArr.length > 0) {
                        child.id = filtedArr[0].id;
                        if (+filtedArr[0].requiredFlag === 1) {
                            defaultCheckedKeys.push(filtedArr[0].qualificationConfigCode);
                        }
                    }
                    return child;
                });
                return data;
            }));
            this.$refs.tree.setCheckedKeys(defaultCheckedKeys);
        }
    },
    watch: {
        qlfData(val) {
            dictWithUrl('SRM_QUALITY_TYPE,SRM_BASIC_QUALITY').then(res => {
                if (res && res.data) {
                    this.initTree(res.data['SRM_QUALITY_TYPE'], res.data['SRM_BASIC_QUALITY']);
                    this.setData(val);
                }
            });
        }
    }
};
</script>

<style lang="less">
    .custom-tree-node_input {
        margin-left: 10px;
        width: 30px;

        .el-input__inner {
            height: 19px;
        }
    }
</style>
